import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  GET_ALL_ROLES_FOR_ORG,
} from "@routes";

const apiConfig = [
  {
    name: "getAllRolesForOrg",
    method: "get",
    url: GET_ALL_ROLES_FOR_ORG,
    stateKey: "allUserRolesForOrgData",
  },
];

const customReducers = {
  initialState: {
    allUserRolesForOrgData: [],
    selectedData: {},
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "organization",
  apiConfig,
  customReducers,
);

const organizationSlice = slice;

export default organizationSlice.reducer;

export const actionsExports = actions;

export const {
  getAllRolesForOrg,
} = thunks;

export const { rowSelect } =
  actionsExports;
